import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";

const IconCircle = ({ color = {COLOR_PRIMARY} }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="6"
      viewBox="0 0 6 6"
    >
      <circle
        id="Elipse_1863"
        data-name="Elipse 1863"
        cx="3"
        cy="3"
        r="3"
        fill={color}
      />
    </svg>
  );
};

export default IconCircle;
